export default {
  "form.required": "Input is required",
  "form.maxLength": "Exceeded maximum length",
};
